import { on, select, removeClass, addClass } from 'modules/dom'

const body = document.body
const ACTIVATE_CLASS = 'sidebar-detail--activate'

export default function (el) {
  const moreInformationButton = select('.js-more-info', body)
  const closeButton = select('.js-close-sidebar', el)
  const activateSidebarDetail = () => addClass(ACTIVATE_CLASS, body)
  const deactivateSidebarDetail = () => removeClass(ACTIVATE_CLASS, body)
  if (moreInformationButton) {
    on('click', activateSidebarDetail, moreInformationButton)
  }
  if (closeButton) {
    on('click', deactivateSidebarDetail, closeButton)
  }
}
